import uploadAvatarOpenTemplate from "./upload-avatar-open.html";

import {uploadAvatarOpenController} from "./upload-avatar.controllers";

import "./upload-avatar.scss";

export const uploadAvatarOpenComponent = {
	template: uploadAvatarOpenTemplate,
	controller: uploadAvatarOpenController,
	controllerAs: "uploadAvatarOpen",
	require: {
		usersUpdate: "^^usersUpdate"
	}
};


// WEBPACK FOOTER //
// ./sources/utility/upload-avatar/upload-avatar.components.js